import { Injectable, NgModule, Component, ViewChild, Input, Output, EventEmitter, defineInjectable } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var NgxBootstrapSliderService = /** @class */ (function () {
    function NgxBootstrapSliderService() {
    }
    NgxBootstrapSliderService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] },
    ];
    /** @nocollapse */
    NgxBootstrapSliderService.ctorParameters = function () { return []; };
    /** @nocollapse */ NgxBootstrapSliderService.ngInjectableDef = defineInjectable({ factory: function NgxBootstrapSliderService_Factory() { return new NgxBootstrapSliderService(); }, token: NgxBootstrapSliderService, providedIn: "root" });
    return NgxBootstrapSliderService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var NgxBootstrapSliderComponent = /** @class */ (function () {
    function NgxBootstrapSliderComponent() {
    }
    /**
     * @return {?}
     */
    NgxBootstrapSliderComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    NgxBootstrapSliderComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mv-ngx-bootstrap-slider',
                    template: "\n    <p>\n      ngx-bootstrap-slider works!\n    </p>\n  ",
                    styles: []
                },] },
    ];
    /** @nocollapse */
    NgxBootstrapSliderComponent.ctorParameters = function () { return []; };
    return NgxBootstrapSliderComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var SliderComponent = /** @class */ (function () {
    function SliderComponent() {
        this.initialOptions = {};
        this.valueChange = new EventEmitter();
        // The following events are emitted
        this.slide = new EventEmitter();
        this.slideStart = new EventEmitter();
        this.slideStop = new EventEmitter();
        this.change = new EventEmitter();
    }
    Object.defineProperty(SliderComponent.prototype, "style", {
        // This property is not applied to the underlying slider element
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (this.slider) {
                this.slider.getElement().setAttribute('style', value);
            }
            else {
                this.initialStyle = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "value", {
        // Handle the value (two-way)
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (this.slider) {
                this.slider.setValue(value);
            }
            else {
                this.initialOptions.value = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "min", {
        // The following properties are applied to the underlying slider element
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.changeAttribute('min', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "max", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.changeAttribute('max', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "step", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.changeAttribute('step', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "precision", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.changeAttribute('precision', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "orientation", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.changeAttribute('orientation', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "range", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.changeAttribute('range', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "selection", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.changeAttribute('selection', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "tooltip", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.changeAttribute('tooltip', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "tooltipSplit", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.changeAttribute('tooltip_split', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "tooltipPosition", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.changeAttribute('tooltipPosition', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "handle", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.changeAttribute('handle', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "reversed", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.changeAttribute('reversed', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "rtl", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.changeAttribute('rtl', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "enabled", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.changeAttribute('enabled', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "naturalArrowKeys", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.changeAttribute('natural_arrow_keys', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "ticks", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.changeAttribute('ticks', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "ticksPositions", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.changeAttribute('ticks_positions', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "ticksLabels", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.changeAttribute('ticks_labels', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "ticksSnapBounds", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.changeAttribute('ticks_snap_bounds', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "ticksTooltip", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.changeAttribute('ticks_tooltip', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "scale", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.changeAttribute('scale', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "labelledBy", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.changeAttribute('labelledby', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "rangeHighlights", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.changeAttribute('rangeHighlights', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "formatter", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.changeAttribute('formatter', value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    SliderComponent.prototype.addChangeListeners = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.slider.on('slide', function (value) {
            _this.slide.emit(value);
        });
        this.slider.on('slideStart', function (value) {
            _this.slideStart.emit(value);
        });
        this.slider.on('slideStop', function (value) {
            _this.slideStop.emit(value);
        });
        this.slider.on('change', function (event) {
            _this.change.emit(event);
            _this.valueChange.emit(event.newValue);
        });
    };
    /**
     * @return {?}
     */
    SliderComponent.prototype.prepareSlider = /**
     * @return {?}
     */
    function () {
        // We need to add the change listeners again after each refresh
        this.addChangeListeners();
        // Add the styling to the element
        this.slider.getElement().setAttribute('style', this.initialStyle);
    };
    /**
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    SliderComponent.prototype.changeAttribute = /**
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    function (name, value) {
        if (this.slider) {
            this.slider.setAttribute(name, value);
            this.slider.refresh();
            this.prepareSlider();
        }
        else {
            this.initialOptions[name] = value;
        }
    };
    /**
     * @return {?}
     */
    SliderComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        // Don't set the value over the initial options, because it will alway
        // be reset. This option seems to be a little buggy.
        var /** @type {?} */ value = undefined;
        if (this.initialOptions.value) {
            value = this.initialOptions.value;
            delete this.initialOptions['value'];
        }
        this.slider = new Slider(this.sliderElement.nativeElement, this.initialOptions);
        if (value) {
            this.slider.setValue(value);
        }
        this.prepareSlider();
    };
    SliderComponent.decorators = [
        { type: Component, args: [{
                    selector: 'mv-slider',
                    template: "<input #slider>",
                    styles: [""]
                },] },
    ];
    /** @nocollapse */
    SliderComponent.ctorParameters = function () { return []; };
    SliderComponent.propDecorators = {
        sliderElement: [{ type: ViewChild, args: ['slider',] }],
        style: [{ type: Input }],
        value: [{ type: Input }],
        valueChange: [{ type: Output }],
        min: [{ type: Input }],
        max: [{ type: Input }],
        step: [{ type: Input }],
        precision: [{ type: Input }],
        orientation: [{ type: Input }],
        range: [{ type: Input }],
        selection: [{ type: Input }],
        tooltip: [{ type: Input }],
        tooltipSplit: [{ type: Input }],
        tooltipPosition: [{ type: Input }],
        handle: [{ type: Input }],
        reversed: [{ type: Input }],
        rtl: [{ type: Input }],
        enabled: [{ type: Input }],
        naturalArrowKeys: [{ type: Input }],
        ticks: [{ type: Input }],
        ticksPositions: [{ type: Input }],
        ticksLabels: [{ type: Input }],
        ticksSnapBounds: [{ type: Input }],
        ticksTooltip: [{ type: Input }],
        scale: [{ type: Input }],
        labelledBy: [{ type: Input }],
        rangeHighlights: [{ type: Input }],
        formatter: [{ type: Input }],
        slide: [{ type: Output }],
        slideStart: [{ type: Output }],
        slideStop: [{ type: Output }],
        change: [{ type: Output }]
    };
    return SliderComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var NgxBootstrapSliderModule = /** @class */ (function () {
    function NgxBootstrapSliderModule() {
    }
    NgxBootstrapSliderModule.decorators = [
        { type: NgModule, args: [{
                    imports: [],
                    declarations: [NgxBootstrapSliderComponent, SliderComponent],
                    exports: [
                        NgxBootstrapSliderComponent,
                        SliderComponent
                    ]
                },] },
    ];
    return NgxBootstrapSliderModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { NgxBootstrapSliderService, NgxBootstrapSliderComponent, NgxBootstrapSliderModule, SliderComponent };

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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